// extracted by mini-css-extract-plugin
export var disabled = "_1k-a";
export var hierarchyLinkGray = "_1k-4";
export var hierarchyLinkUnderline = "_1k-3";
export var hierarchyPrimary = "_1k-0";
export var hierarchySecondary = "_1k-1";
export var hierarchyTertiary = "_1k-2";
export var pressed = "_1k-6";
export var themeAction = "_1k-5";
export var themeDestructive = "_1k-8";
export var themeNormal = "_1k-7";
export var themeSuccess = "_1k-9";